export { default as LogoAmarenco } from './LogoAmarenco'
export { default as CollaboratorsAmarenco } from './CollaboratorsAmarenco'
export { default as PowerAmarenco } from './PowerAmarenco'
export { default as InvestismentAmarenco } from './InvestismentAmarenco'
export { default as SolarAmarenco } from './SolarAmarenco'
export { default as InstallationAmarenco } from './InstallationAmarenco'
export { default as LaureatAmarenco } from './LaureatAmarenco'
export { default as ProjectAmarenco } from './ProjectAmarenco'
export { default as PresidentAmarenco } from './PresidentAmarenco'
